<template>
  <div class="container wc-container">
    <h3 style="margin-bottom:30px;">Who is Watching</h3>
    <Card style="margin-bottom:16px;">
      <Select v-model="selectedStream" style="width:200px">
        <Option value="all" key="all">All Streams</Option>
        <Option v-for="item in streams" :value="item._id" :key="item._id">{{ item.name }}</Option>
      </Select>
    </Card>

    <Table
      :loading="loading"
      width="100%"
      height="500"
      border
      :columns="columns"
      :data="attData"
      size="small"
      ref="table"
    ></Table>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      loading: true,
      columns: [],
      selectedStream: null
    };
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    }),
    ...mapGetters("stream", {
      streamsInStore: "find"
    }),
    ...mapGetters("session-connections", {
      connectionsInStore: "find"
    }),
    streams() {
      this.selectedStream = "all";
      return this.streamsInStore({ query: {} }).data;
    },
    attData() {
      let query = {
        isWatching: true,
        "timers.watch": { $gt: 0 },
        webcastId: this.webcast._id
      };

      if (this.selectedStream != "all") {
        query["streamId"] = this.selectedStream;
      }

      let connections = this.connectionsInStore({ query: query });
      let resp = connections.data;
      let rows = [];

      if (resp.length <= 0) {
        this.loading = false;
        return rows;
      }

      /* Generate column names if not generated before */
      if (this.$data.columns.length <= 0) {
        let sampleRow = this.sampleRow();

        if (sampleRow.reg) {
          _.forEach(sampleRow.reg.info, (value, key) => {
            this.$data.columns.push({
              title: _.capitalize(key),
              key: key,
              width: 160
            });
          });
        }

        this.$data.columns.push({
          title: "Started to Watch",
          key: "watchStarted",
          width: 160,
          align: "center"
        });

        if (sampleRow.device) {
          _.forEach(sampleRow.device, (value, key) => {
            if (
              key != "_id" &&
              key != "createdAt" &&
              key != "updatedAt" &&
              key != "__v"
            ) {
              if (key == "city") {
                key = "ip_city";
              }
              this.$data.columns.push({
                title: _.capitalize(key),
                key: key,
                width: 160
              });
            }
          });
        }
      }

      /* Prepare data for the table */

      _.forEach(resp, (row, key) => {
        let rowRecord = {};

        if (this.webcast.hasAudioRoom) {
          rowRecord["callerId"] = row.callerId;
          rowRecord["handRaisedAt"] = row.handRaisedAt;
          rowRecord["channel"] = row.channel;
        }

        if (row.reg) {
          if (row.reg.info) {
            _.forEach(row.reg.info, (value, key) => {
              rowRecord[key] = value;
            });
          }
        } else {
        }

        if (row.device) {
          _.forEach(row.device, (value, key) => {
            if (key == "city") {
              key = "ip_city";
            }
            rowRecord[key] = value;
          });
        }
        rowRecord["watchStarted"] = moment(row.watchStarted).format("LLL");
        rows.push(rowRecord);
      });

      this.loading = false;
      console.log(rows);
      return rows;
    }
  },
  methods: {
    ...mapActions("session-connections", {
      findConnectionsAction: "find"
    }),
    ...mapActions("stream", {
      findStreamsAction: "find"
    }),
    sampleRow() {
      let query = {
        isWatching: true,
        "timers.watch": { $gt: 0 },
        webcastId: this.webcast._id,
        channel: { $nin: ["Audio Room"] }
      };

      if (this.selectedStream != "all") {
        query["streamId"] = this.selectedStream;
      }

      let connections = this.connectionsInStore({ query: query }).data[0];
      return connections;
    }
  },
  created() {
    this.findStreamsAction({
      query: {
        webcastId: this.webcast._id
      }
    });

    console.log(this.webcast.currentSessionId);

    this.findConnectionsAction({
      query: {
        webcastId: this.webcast._id,
        sessionId: this.webcast.currentSessionId
        //updatedAt: { $gte: moment(new Date()).subtract(1, "minutes").toDate().toISOString()}
      }
    });
  }
};
</script>

<style>
</style>
